import AnimeSelected from "../components/animeList/AnimeSelected";

const SelectedAnime = () => {
  return <AnimeSelected />;
};

export default SelectedAnime;
